import { Components, Theme } from '@mui/material/styles'

export const appBarTheme: Components<Theme>['MuiAppBar'] = {
  styleOverrides: {
    root: {
      boxShadow: 'none',
      '& hr': {
        borderColor: 'rgba(0, 0, 0, 0.12)',
      },
    },
  },
}
